import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Link from 'next/link';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';

const Faq: FC = () => {
  //seo block
  const SEO_TITLE = 'Как пользоваться библиотекой';
  const SEO_DESCRIPTION = 'Как пользоваться библиотекой: faq :: BookZ.ru';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref="/feedback" isSmallPage breadcrumbs={<Breadcrumbs firstPageName="Вопросы по скачиванию/чтению книг" />}>
      <h4 className="pageTitle">Рекомендуемые программы</h4>
      <div className="pageBlock">1. Все тексты находящиеся в библиотеке можно либо прочитать онлайн, либо скачать в архивированном виде. Для разархивирования используйте программы: WinRar, WinZip и т.п.</div>
      <div className="pageBlock">2. Если после извлечения текста книги из архива его невозможно прочитать (отображаются "иероглифы" вместо текста), скачайте редактор Aditor или любой другой, способный определять кодировки "на лету".</div>

      <h4 className="pageTitle">Новинки книг в формате RSS</h4>
      <div className="pageBlock">
        В нашей библиотеке имеется возможность получать новости о новых книгах в формате RSS. Подробнее о формате RSS и используемых программах для чтения RSS-новостей можно прочитать{' '}
        <Link prefetch={false} className="pageLink" href="/rss">
          здесь
        </Link>
        .
      </div>

      <h4 className="pageTitle">Разрешение проблем</h4>
      <div>Если при скачивании архива книги возникают проблемы (выдается ошибка "документ не найден" или требуется ввести логин и пароль), нажмите кнопку "обновить" ("refresh") в Вашем браузере.</div>
    </Layout>
  );
};
export default Faq;
